export var types = {
  warning: 'warning',
  ghost: 'ghost'
};
export var typesArray = Object.values(types);